import { useEffect, useRef } from "react";

export const Cursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    let raf;
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX;
    let ringY = mouseY;

    const move = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%,-50%)`;
      }
    };

    const tick = () => {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%,-50%)`;
      }
      raf = requestAnimationFrame(tick);
    };

    const over = (e) => {
      const t = e.target;
      if (t.closest && t.closest("a, button, [role='button'], .st-interactive, input, textarea, .lbadge")) {
        dotRef.current?.classList.add("hover");
        ringRef.current?.classList.add("hover");
      }
    };
    const out = (e) => {
      const t = e.target;
      if (t.closest && t.closest("a, button, [role='button'], .st-interactive, input, textarea, .lbadge")) {
        dotRef.current?.classList.remove("hover");
        ringRef.current?.classList.remove("hover");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    window.addEventListener("mouseout", out);
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mouseout", out);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="st-cursor-dot" data-testid="st-cursor-dot" />
      <div ref={ringRef} className="st-cursor-ring" data-testid="st-cursor-ring" />
    </>
  );
};
